import { getStaticUrl } from 'src/utils/helpers'

export function getBrandingCssUri(colors) {
  const colorsArray = [
    `b=${encodeURIComponent(colors.brandColor)}`,
    `bc=${encodeURIComponent(colors.brandContrastColor)}`,
    `db=${encodeURIComponent(colors.desktopBrandColor || colors.brandColor)}`,
    `dbc=${encodeURIComponent(colors.desktopBrandContrastColor || colors.brandContrastColor)}`,
    `a=${encodeURIComponent(colors.actionColor)}`,
  ]

  return `${getStaticUrl()}/get-branding-styles.json?${colorsArray.join('&')}`
}
